import { render, staticRenderFns } from "./RenewalSection.vue?vue&type=template&id=f0e51d30"
import script from "./RenewalSection.vue?vue&type=script&lang=js"
export * from "./RenewalSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports